import { baseTemplateParams } from '../shared/baseParams.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  headerBgColor: '#000000',
  emailTitle: 'Welcome To {{hotelName}}',
  ctaText: 'Discover more',
  ctaBackgroundColor: '#000000',
  ctaTextColor: '#ffffff',
  col1LinkText: 'Explore more',
  col2LinkText: 'Explore more',
  galleryTitle: 'Discover {{hotelName}}',
  discoverBtn1: 'Destination 1',
  discoverBtn2: 'Destination 2',
  discoverBtn3: 'Destination 3',
  discoverBtn4: 'Destination 4',
  preheaderText: 'Welcome — discover experiences and destinations tailored for you.',
  subject: 'Welcome to our hotels',
  selectedTemplate: 'destinationShowcase',
  shellTemplateKey: 'destinationShowcase',
  logoWidth: '130px',
  logoHeight: '30px',
  hotelName: '',
  hotelAddress: '',
  hotelCityStateZip: '',
  hotelPhone: '',
  hotelWebsite: '',
  hotelWebsiteUrl: '',
  richtextFields: {
    ...baseTemplateParams.richtextFields,
    bodyHtml: `Dear :token{key="guestName" label="First name"},

It is our great pleasure to welcome you. By signing up, you have unlocked exclusive offerings and inspiring stories from {{hotelName}}.

We look forward to hosting you and sharing what makes every stay memorable.`,
    col1Html: `### Timeless hospitality

Our properties embrace creative innovation and cherished tradition to offer regionally authentic, deeply meaningful experiences.`,
    col2Html: `### Exceptional indulgences

As a guest, you will be invited to special happenings — from dining experiences to spa escapes and seasonal stay packages.`
  }
}

export default defaultTemplateParams
